import { Link, useNavigate } from 'react-router-dom';
import {useTranslation} from 'react-i18next'

import { FaFacebook, FaInstagram } from "react-icons/fa";

let fecha = new Date()
let anio = fecha.getFullYear()

export const Footer = () => {
    const navigate = useNavigate()   

    const { t } = useTranslation()    

    return (
    <footer className="footer">
        <div className='container'>
            <div className='footer-flex'>
                <div className='footer-brand'>
                    <img src="/image/logos/LOGO_T1.png" alt='Logo'></img>
                    <p>{t("foot_info")}</p>
                    <a href='./reclamaciones'><img style={{borderRadius:"0.2rem"}} src="/image/libroReclamaciones.png" alt='Libro de Reclamaciones'></img></a>                    
                </div>
                <div>
                    <div className='footer-header'>{t("foot_explorar")}</div>
                    <div className='link-deco text-center text-secundario'>
                        <span style={{cursor:'pointer'}} onClick={()=>navigate('/inicio')}>{t("nav_inicio")}</span>
                    </div>
                    <div className='link-deco text-center text-secundario'>
                        <span style={{cursor:'pointer'}} onClick={()=>navigate('/nosotros')}>{t("nav_nosotros")}</span>
                    </div>
                    <div className='link-deco text-center text-secundario'>
                        <span style={{cursor:'pointer'}} onClick={()=>navigate('/experiencias')}>{t("nav_experiencias")}</span>
                    </div>
                    <div className='link-deco text-center text-secundario'>
                        <span style={{cursor:'pointer'}} onClick={()=>navigate('/tienda')}>{t("nav_tienda")}</span>
                    </div>
                    <div className='link-deco text-center text-secundario'>
                        <span style={{cursor:'pointer'}} onClick={()=>navigate('/galeria')}>{t("nav_galeria")}</span>
                    </div>                    
                </div>
                <div className='footer-social'>
                    <div className='footer-header'>{t("foot_siguenos")}</div>
                    <div className='footer-social-icons'>
                        <Link to={"https://www.facebook.com/altosdeazpitia/"} target="_blank"><FaFacebook/></Link>
                        <Link to={"https://www.instagram.com/altosdeazpitia/"} target="_blank"><FaInstagram/></Link>
                    </div>
                    <div className='footer-header mt-3'>{t("foot_contactanos")}</div>
                    <div className="link-deco text-secundario">
                        <span style={{cursor:'pointer'}} onClick={e=>navigate('/contacto')}>pedidos@altosdeazpitia.com</span>
                    </div>
                </div>
            </div>
            <div className='footer-bottom'>
                <div>© {anio} Altos de Azpitia — {t("foot_copyright")}</div>
                <div>{t("foot_msg_advertencia")}</div>
            </div>
        </div>            
    </footer>
    )
}